import { z } from 'zod';
import { CONFIRMATION_BUTTON_LABEL_MAX, CONFIRMATION_PROMPT_MAX } from '@irl/types';
const button = z.object({
    enabled: z.boolean(),
    label: z.string().trim().min(1).max(CONFIRMATION_BUTTON_LABEL_MAX),
    requireText: z.boolean(),
    prompt: z.string().trim().max(CONFIRMATION_PROMPT_MAX).default(''),
});
export const confirmationButtonsSchema = z
    .object({ done: button, decline: button })
    .refine((value) => value.done.enabled || value.decline.enabled, {
    message: 'Enable at least one confirmation button',
});
//# sourceMappingURL=confirmation-buttons.js.map